const modalOverlay = document.getElementById('modalOverlay');

function openModal() {
    modalOverlay.classList.add('active');
    document.body.style.overflow = 'hidden';
}

function closeModal() {
    modalOverlay.classList.remove('active');
    document.body.style.overflow = '';
}

// Close modal when clicking outside
modalOverlay.addEventListener('click', function(e) {
    if (e.target === modalOverlay) {
        closeModal();
    }
});

// Close modal on ESC key
document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && modalOverlay.classList.contains('active')) {
        closeModal();
    }
});


$( document ).ready(function() {
    $('#lp-form').submit(function(evt){
        evt.preventDefault();

        grecaptcha.ready(function() {
            grecaptcha.execute('6LeZaSgsAAAAANv9ipG4EYhd_hFgftdpkvQ4VpCA', {action: 'submit'}).then(function(token) {

                var formData = {
                    fname:   $("#fullName").val(),
                    email:   $("#email").val(),
                    company: $("#company").val(),
                    phone:   $("#phone").val(),
                    message: $("#message").val(),
                    website: $("#website").val(),
                    recaptchaToken: token
                };

                $.ajax({
                    type: "POST",
                    url: "../../inc/process-lp.php",
                    data: formData,
                    dataType: "json",
                    encode: true,
                }).done(function (data) {
                    console.log(data);
                    if (!data.success) {

                    } else {
                        $('.modal-content .success-message').css('display', 'block');
                        $('.modal-content .modal-inner').css('display', 'none');
                        setTimeout(function() {
                            closeModal();
                        },2000);
                    }
                }).fail(function (jqXHR, textStatus, errorThrown) {
                    console.error("Error: " + textStatus);
                    console.error(errorThrown);
                });

            });
        });
    });
});